const StatisticalEmp = () =>
  import('@/views/main/live/statisticalEmp/StatisticalEmp.vue')
export default {
  path: '/main/live/statisticalEmp',
  name: 'StatisticalEmp',
  component: StatisticalEmp,
  children: []
}
